var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logoHeader"},[_c('div',{staticClass:"appName"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logoImageData,"id":"logoImage"}}),_c('span',[_vm._v(_vm._s(_vm.title)+" Designer")])])])}
var staticRenderFns = []

export { render, staticRenderFns }